<template>
  <div class="modal-content-install-app-macos">
    <div class="modal-content-install-app__img-wrapper">
      <div class="modal-content-install-app__img-title">
        <atomic-image src="/img/icons/safari.svg" />
        <span>{{ getContent(popupsData, defaultLocalePopupsData, 'installApp.safari') }}</span>
      </div>
      <atomic-image alt="how-to-install-on-macOS" class="modal-content-install-app__img" src="/img/uploads/install-app-macos.png" />
    </div>
    <ul class="modal-content-install-app__instruction-steps">
      <li class="modal-content-install-app__instruction-step" v-for="(step, index) in steps" :key="index">
        <atomic-icon :id="step.icon" />
        <span>{{ step.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  const globalStore = useGlobalStore();
  const { getContent } = useProjectMethods();

  const {
    popupsData,
    defaultLocalePopupsData,
  } = storeToRefs(globalStore);

  const steps = computed(() => getContent(popupsData.value, defaultLocalePopupsData.value, 'installApp.macos.steps'));
</script>

<style src="~/assets/styles/components/modal-content/install-app-macos.scss" lang="scss" />
